    <div [ngClass]="{'strava-section-medium': !isSmall, 'strava-section-small': isSmall}" #stravaElement>
        <div class="img-wrapper">
            <div class="gradient"></div>
            <img [src]="stravaSection.thumbnails.medium" alt="" srcset="">
        </div>

        <div class="title-wrapper">
            <div class="section-title">{{stravaSection.name}}</div>
        </div>

        <div class="info-wrapper">
            <!--* distance -->
            <div class="counter">
                <div class="value">{{stravaSection.distance}}</div>
                <div class="unit">{{stravaSection.distance_unit}}</div>
                <span class="icon icon-double_arrow"></span>
            </div>

            <div class="counter-divider"></div>
            <!--* duration -->
            <div class="counter">
                <div class="value">{{stravaSection.duration}}</div>
                <div class="unit">{{stravaSection.duration_unit}}</div>
                <span class="icon icon-timer-classic"></span>
            </div>

            <div class="counter-divider"></div>
            <!--* positive_slope -->
            <div class="counter">
                <div class="value">{{stravaSection.positive_slope}}</div>
                <div class="unit">{{stravaSection.positive_slope_unit}}</div>
                <span class="icon icon-slope"></span>
            </div>
        </div>

        <span class="strava-link" (click)="stravaLinkClick(stravaSection.strava_url)"
            translate>
            watch.strava_sections.element.btn<span *ngIf="!isSmall" class="icon icon-arrow-right"></span>
        </span>
    </div>